import { render, staticRenderFns } from "./sub-factor-filter.vue?vue&type=template&id=4f1d9ed3&scoped=true&"
import script from "./sub-factor-filter.vue?vue&type=script&lang=js&"
export * from "./sub-factor-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1d9ed3",
  null
  
)

export default component.exports